import React from 'react';
import DnDRowContainer from 'components/lib/tables/dnd/DnDRowContainer';
import DnDBucketFooter from 'components/lib/tables/dnd/DnDBucketFooter';
import styles from 'styles/components/lib/tables/dnd/dndNewBucket.css';


export default class DnDNewBucket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      isCollapsed: false
    }
    this.handleClickExpander = this.handleClickExpander.bind(this);
    this.handleNewName = this.handleNewName.bind(this);
  }
  handleClickExpander() {
    this.setState({ isCollapsed: !this.state.isCollapsed});
    if ( !!this.props.bucket.key ) this.props.onCancel();
  }
  handleNewName(name) {
    this.setState({ name });
  }
  render() {
    let { bucket, row } = this.props;
    let { isCollapsed } = this.state;
    return (
      <div className={styles.newBucketContainer} style={{maxHeight: `${isCollapsed ? '47px': 'none'}`}}
          onDragOver={this.props.onDragOver}
          onDrop={!this.props.isEditing ? (e) => this.props.onDrop(e, { index: 0 } ) : null}>
            { bucket.childrenKeys.length > 0 ?
                <DnDRowContainer ref='newBucket'
                  key="dndNewRowContainer"
                  columns={this.props.columns}
                  draggedRowsKeys={this.props.draggedRowsKeys}
                  errorMessage={this.props.errorMessage}
                  isNewBucket={true}
                  isNewBucketCreation={this.props.isNewBucketCreation}
                  name={this.state.name}
                  onCancel={this.props.onCancel}
                  onCloseEdit={this.props.onCloseEdit}
                  onDragAdd={this.props.onDragAdd}
                  onDeleteChild={this.props.onDeleteChild}
                  onEditNewBucket={this.props.onEditNewBucket}
                  onNewNameChange={this.handleNewName}
                  onSetParent={this.props.onSetParent}
                  onSubmit={this.props.onSubmit}
                  packages={this.props.packages}
                  row={bucket}
                  selectedParent={this.props.parent}
                  isTouchDevice={this.props.isTouchDevice}/>
              : <div className={styles.emptyBucket}>
                  <h5>Drag & Drop</h5>
                  <h6>ticket types here to create a group</h6>
                </div>
            }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/dnd/DnDNewBucket.js